// 判断是否是手机端
export const isH5HandleClient = () => {
    if (typeof window === 'undefined') return false;
    const clientWidth = window.innerWidth;
    if (clientWidth <= 1024) {
        return true;
    }
    return false;
};
